import React, { FC } from "react";

import "./SearchResponseText.scss";

export interface SearchResponseTextProps {
    readonly text: string;
    readonly pClass?: string;
}

export const SearchResponseText: FC<SearchResponseTextProps> = props => {
    const { text, pClass } = props;

    return (
        <div className="xapp-search-response-text">
            <p className={pClass}>
                {text}
            </p>
        </div>
    );
};